import type { ModalStateType, ModalDataType } from "@/types";

export const useModalState = () => {
  const data = useState<ModalStateType>("modal", () => ({ type: null }));

  function setData(type: ModalStateType["type"], modalData?: ModalDataType) {
    if (type === null) {
      data.value = { type: null };
      return;
    }

    data.value = {
      type,
      data: modalData,
    };
  }

  function getData() {
    return data.value?.data;
  }

  return {
    data,
    setData,
    getData,
  };
};
